import { render, staticRenderFns } from "./PoundageInfo.vue?vue&type=template&id=17804fd5&scoped=true&"
import script from "./PoundageInfo.vue?vue&type=script&lang=js&"
export * from "./PoundageInfo.vue?vue&type=script&lang=js&"
import style0 from "./PoundageInfo.vue?vue&type=style&index=0&id=17804fd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17804fd5",
  null
  
)

export default component.exports